import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ApiHelper } from "../../../utils/apiHelper";
import { toast } from "react-toastify";

export const fetchOtherTopics = createAsyncThunk(
    "otherTopics/fetchOtherTopics",
    async (startupId, { rejectWithValue }) => {
        try {
            const response = await ApiHelper.get(`/startup/${startupId}/product-other-topics`);
            if (response.data.code === "00000") {
                return response.data.otherTopics;
            }
            throw new Error("Failed to fetch other topics");
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const createOtherTopic = createAsyncThunk(
    "otherTopics/createOtherTopic",
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await ApiHelper.post("/startup/product-other-topic", data);
            if (response.data.code === "00000") {
                toast.success("Konu başarıyla eklendi");
                await dispatch(fetchOtherTopics(data.startupId));
                return response.data;
            }
            throw new Error("Failed to create other topic");
        } catch (error) {
            toast.error("Konu eklenirken bir hata oluştu");
            return rejectWithValue(error.message);
        }
    }
);

export const deleteOtherTopic = createAsyncThunk(
    "otherTopics/deleteOtherTopic",
    async (additionalTopicId, { rejectWithValue }) => {
        try {
            console.log("additionalTopicId", additionalTopicId);
            const response = await ApiHelper.delete(`/startup/product-other-topic`, {
                data: { additionalTopicId }
            });
            if (response.data.code === "00000") {
                toast.success("Konu başarıyla silindi");
                return { additionalTopicId };
            }
            throw new Error("Failed to delete other topic");
        } catch (error) {
            toast.error("Konu silinirken bir hata oluştu");
            return rejectWithValue(error.message);
        }
    }
);

const otherTopicsSlice = createSlice({
    name: "otherTopics",
    initialState: {
        topics: [],
        loading: false,
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchOtherTopics.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchOtherTopics.fulfilled, (state, action) => {
                state.loading = false;
                state.topics = action.payload;
                state.error = null;
            })
            .addCase(fetchOtherTopics.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(deleteOtherTopic.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteOtherTopic.fulfilled, (state, action) => {
                state.loading = false;
                state.topics = state.topics.filter(topic => topic.topicId !== action.payload.topicId);
                state.error = null;
            })
            .addCase(deleteOtherTopic.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export default otherTopicsSlice.reducer;
